import React from "react";
import { Button, Checkbox } from "antd";

interface OptionProps {
  id: number;
  name: string;
}
interface MarketSelectionProps {
  label: string;
  options: OptionProps[];
  selected: OptionProps[];
  setSelected: (selected: OptionProps[]) => void;
  otherInputValue?: string;
  checked: boolean;
  showCheckBox?: boolean;
  setChecked: (checked: boolean) => void;
  setOtherInputValue?: (value: string) => void;
}

const MarketSelection: React.FC<MarketSelectionProps> = ({
  label,
  options = [],
  selected = [],
  otherInputValue,
  setOtherInputValue,
  checked,
  setSelected,
  setChecked,
  showCheckBox = true,
}) => {
     return (
    <div className="col-span-1">
      {showCheckBox ? (
        <Checkbox
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
          className="common-bold-label"
        >
          {label}
        </Checkbox>
      ) : (
        <p className="common-bold-label">{label}</p>
      )}

      {checked && (
        <div className="flex flex-wrap gap-x-2 gap-y-2 mt-[24px]">
          {options.map((option) => (
            <Button
              type="text"
              key={option.id}
              onClick={() => {
              
                 const isAlreadySelected = selected.some((item) => item.id === option.id);
              
                if (isAlreadySelected && option.name === "Other") {
                  return;
                } else {
                  if (option.name === "None") {
                    setSelected([option]); // Clear all, only select 'None'
                  } else {
                    const updatedSelection = isAlreadySelected
                      ? selected.filter((item) => item.id !== option.id)
                      : [
                          ...selected.filter((item) => item.name !== "None"),
                          option,
                        ]; // Remove 'None' if present
                    setSelected(updatedSelection);
                  }
                }
              }}
              className={`cursor-pointer rounded-[30px] px-[20px] py-[10px]  text-sm font-normal font-['Inter'] leading-tight  transition ${
                selected.some((item) => item.id === option.id)
                  ? "text-[#1849a9] "
                  : "text-[#1d2939]"
              }`}
              style={{
                border: `1px solid ${
                  selected.some((item) => item.id === option.id)
                    ? "#53b1fd"
                    : "#e4e7ec"
                }`,
                backgroundColor: `${
                  selected.some((item) => item.id === option.id)
                    ? "#d1e9ff"
                    : ""
                }`,
              }}
              
            >
              {selected.some((item) => item.id === option.id) && option.name === "Other" ? (
                <div>
                  {" "}
                  <input
                    type="text"
                    placeholder="Your Answer"
                    className="outline-none border-none bg-transparent text-[#1d2939] text-sm "
                    value={otherInputValue}
                    onChange={(e) =>
                      setOtherInputValue && setOtherInputValue(e.target.value)
                    }
                  />
                </div>
              ) : (
                option.name
              )}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};

export default MarketSelection;
